import { render, staticRenderFns } from "./StatusFieldEditor.vue?vue&type=template&id=09ecf66e&scoped=true&"
import script from "./StatusFieldEditor.vue?vue&type=script&lang=ts&"
export * from "./StatusFieldEditor.vue?vue&type=script&lang=ts&"
import style0 from "./StatusFieldEditor.vue?vue&type=style&index=0&id=09ecf66e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ecf66e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
